import { render, staticRenderFns } from "./food-list.vue?vue&type=template&id=288fed8c&"
import script from "./food-list.vue?vue&type=script&lang=ts&"
export * from "./food-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports